export const INVALID_TZ_GUESS = 'invalid-tz-guess';